import { AlarmLevel } from './alarm-level';
import { Port } from './port';

export class SystemAlarmSetting {
    enable: boolean;
    statusString1: string;
    statusString2: string;
    statusString3: string;
    statusString4: string;
    statusString5: string;
    statusString6: string;
    statusString7: string;
    statusString8: string;
    statusString9: string;
    statusString10: string;
    statusString11: string;
    statusString12: string;
    statusString13: string;
    statusString14: string;
    statusString15: string;
    statusString16: string;
    alarmGroupNo: number;
    reposeGroup1No: number;
    reposeGroup2No: number;
    delayTimer: number;
    alarmLevel: AlarmLevel;
}

export const SystemAlarmSettingFns = {
    createDefault,
    createFcuSetting,
    createOpsSetting,
    createFuSetting,
    createCeuSetting,
    createEapSetting,
    createFcuIOSetting,
};

function createDefault(isNull: boolean = false): SystemAlarmSetting {
    return {
        enable: isNull ? false : true,
        statusString1: '',
        statusString2: '',
        statusString3: '',
        statusString4: '',
        statusString5: '',
        statusString6: '',
        statusString7: '',
        statusString8: '',
        statusString9: '',
        statusString10: '',
        statusString11: '',
        statusString12: '',
        statusString13: '',
        statusString14: '',
        statusString15: '',
        statusString16: '',
        alarmGroupNo: 0,
        reposeGroup1No: 0,
        reposeGroup2No: 0,
        delayTimer: 0,
        alarmLevel: isNull ? AlarmLevel.None : AlarmLevel.Alarm,
    };
}

function createOpsSetting(currentSettings?: SystemAlarmSetting): SystemAlarmSetting {
    const setting = createDefault();
    setting.enable = true;

    setting.statusString1 = currentSettings?.statusString1 || 'INIT';
    setting.statusString2 = currentSettings?.statusString2 || 'ETH A';
    setting.statusString3 = currentSettings?.statusString3 || 'ETH B';
    return setting;
}

function createFcuSetting(hasLan = false, hasSerial = false, currentSettings?: SystemAlarmSetting): SystemAlarmSetting {
    const setting = createDefault();
    setting.enable = true;

    setting.statusString1 = currentSettings?.statusString1 || 'RUN';
    setting.statusString2 = currentSettings?.statusString2 || 'INIT';
    setting.statusString3 = currentSettings?.statusString3 || 'SYNC';
    setting.statusString4 = currentSettings?.statusString4 || 'FILES';
    setting.statusString5 = currentSettings?.statusString5 || 'MEM';

    setting.statusString6 = currentSettings?.statusString6 || 'ETH A';
    setting.statusString7 = currentSettings?.statusString7 || 'ETH B';
    setting.statusString8 = hasSerial ? currentSettings?.statusString8 || 'BUS A' : '';
    setting.statusString9 = hasSerial ? currentSettings?.statusString9 || 'BUS B' : '';
    setting.statusString10 = hasLan ? currentSettings?.statusString10 || 'NET A' : '';
    setting.statusString11 = hasLan ? currentSettings?.statusString11 || 'NET B' : '';

    setting.statusString12 = currentSettings?.statusString12 || 'ExCOMM1';
    setting.statusString13 = currentSettings?.statusString13 || 'ExCOMM2';
    setting.statusString14 = currentSettings?.statusString14 || 'ExCOMM3';
    setting.statusString15 = currentSettings?.statusString15 || 'ExCOMM4';
    setting.statusString16 = currentSettings?.statusString16 || 'ExCOMM5';

    return setting;
}

function createFcuIOSetting(): SystemAlarmSetting {
    const setting = createDefault();
    setting.enable = true;

    setting.statusString1 = 'SLOT1';
    setting.statusString2 = 'SLOT2';
    setting.statusString3 = 'SLOT3';
    setting.statusString4 = 'SLOT4';
    setting.statusString5 = 'SLOT5';
    setting.statusString6 = 'SLOT6';
    setting.statusString7 = 'SLOT7';
    setting.statusString8 = 'SLOT8';
    return setting;
}

function createFuSetting(numSlots?: number, currentSettings?: SystemAlarmSetting): SystemAlarmSetting {
    const setting = createDefault();
    setting.enable = true;

    setting.statusString1 = currentSettings?.statusString1 || 'RUN';
    setting.statusString2 = currentSettings?.statusString2 || 'INIT';
    setting.statusString3 = currentSettings?.statusString3 || 'FILES';
    setting.statusString4 = currentSettings?.statusString4 || 'A LINE';
    setting.statusString5 = currentSettings?.statusString5 || 'B LINE';
    if (!numSlots || numSlots == 0) return setting;
    setting.statusString6 = currentSettings?.statusString6 || 'SLOT1';
    setting.statusString7 = currentSettings?.statusString7 || 'SLOT2';
    if (numSlots <= 2) return setting;
    setting.statusString8 = currentSettings?.statusString8 || 'SLOT3';
    if (numSlots <= 3) return setting;
    setting.statusString9 = currentSettings?.statusString9 || 'SLOT4';
    setting.statusString10 = currentSettings?.statusString10 || 'SLOT5';
    if (numSlots <= 5) return setting;
    setting.statusString11 = currentSettings?.statusString11 || 'SLOT6';
    setting.statusString12 = currentSettings?.statusString12 || 'SLOT7';
    setting.statusString13 = currentSettings?.statusString13 || 'SLOT8';
    return setting;
}

function createCeuSetting(ceuPorts?: Port[], currentSettings?: SystemAlarmSetting): SystemAlarmSetting {
    const setting = createDefault();
    setting.enable = true;

    setting.statusString1 = currentSettings?.statusString1 || 'RUN';
    setting.statusString2 = currentSettings?.statusString2 || 'INIT';
    setting.statusString3 = currentSettings?.statusString3 || 'FILES';
    setting.statusString4 = currentSettings?.statusString4 || 'NET A';
    setting.statusString5 = currentSettings?.statusString5 || 'NET B';
    if (!ceuPorts || ceuPorts.length == 0) return setting;

    for (let i = 0; i < ceuPorts.length; i++) {
        const port = ceuPorts[i];
        if (port.use) {
            const string = `Port${port.port}`;
            const statusString = `statusString${port.port + 5}`;
            if (currentSettings) setting[statusString] = currentSettings[statusString] || string;
            else setting[statusString] = string;
        }
    }
    return setting;
}

function createEapSetting(currentSettings?: SystemAlarmSetting): SystemAlarmSetting {
    const setting = createDefault();
    setting.enable = true;

    setting.statusString1 = currentSettings?.statusString1 || 'RUN';
    setting.statusString2 = currentSettings?.statusString2 || 'INIT';

    return setting;
}
